import { HEX_HEIGHT_FACTOR } from '~/composables/grid/constants'
import type { GridShapesMenu, Shape } from '~/types/grid.types'

export enum SHAPE_IDS {
  HEX = 'Hex',
  LARGE_DIAMOND = 'LargeDiamond',
  LARGE_DIAMOND_60 = 'LargeDiamond60',
  LARGE_DIAMOND_120 = 'LargeDiamond120',
  SMALL_DIAMOND = 'SmallDiamond',
  SMALL_DIAMOND_60 = 'SmallDiamond60',
  SMALL_DIAMOND_120 = 'SmallDiamond120',
  LARGE_TRIANGLE_TOP = 'LargeTriangleTop',
  LARGE_TRIANGLE_BOTTOM = 'LargeTriangleBottom',
  SMALL_TRIANGLE_TOP = 'SmallTriangleTop',
  SMALL_TRIANGLE_BOTTOM = 'SmallTriangleBottom',
}

export enum SHAPE_TYPES {
  HEX = 'hex',
  DIAMOND = 'diamond',
  TRIANGLE = 'triangle',
}

export const SHAPES: Shape[] = [
  {
    type: SHAPE_TYPES.HEX,
    id: SHAPE_IDS.HEX,
    icon: 'Hex',
    prefix: 'Hex',
    label: 'Hex',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    sides: 6,
    radius: 60,
    rotation: 90, // konva default drawing is different form feltright standard
  },
  {
    type: SHAPE_TYPES.DIAMOND,
    id: SHAPE_IDS.LARGE_DIAMOND,
    icon: 'LargeDiamond',
    prefix: 'LargeDiamond',
    label: 'Large Diamond',
    w: 120,
    h: Math.round(240 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: SHAPE_TYPES.DIAMOND,
        id: SHAPE_IDS.LARGE_DIAMOND_60,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 60',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 60,
      },
      {
        type: SHAPE_TYPES.DIAMOND,
        id: SHAPE_IDS.LARGE_DIAMOND_120,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 120',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 120,
      },
    ],
  },
  {
    type: SHAPE_TYPES.DIAMOND,
    id: SHAPE_IDS.SMALL_DIAMOND,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: SHAPE_TYPES.DIAMOND,
        id: SHAPE_IDS.SMALL_DIAMOND_60,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 60',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 60,
      },
      {
        type: SHAPE_TYPES.DIAMOND,
        id: SHAPE_IDS.SMALL_DIAMOND_120,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 120',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 120,
      },
    ],
  },
  {
    type: SHAPE_TYPES.TRIANGLE,
    id: SHAPE_IDS.LARGE_TRIANGLE_TOP,
    icon: 'LargeTriangle',
    prefix: 'LargeTriangle',
    label: 'Large Triangle',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: SHAPE_TYPES.TRIANGLE,
        id: SHAPE_IDS.LARGE_TRIANGLE_BOTTOM,
        icon: 'LargeTriangle',
        prefix: 'LargeTriangle',
        label: 'Large Triangle Flipped',
        rotation: 180, // svg icon is rotated
        w: 120,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
  {
    type: SHAPE_TYPES.TRIANGLE,
    id: SHAPE_IDS.SMALL_TRIANGLE_TOP,
    icon: 'SmallTriangle',
    prefix: 'SmallTriangle',
    label: 'Small Triangle',
    w: 60,
    h: Math.round(60 * HEX_HEIGHT_FACTOR),
    children: [
      {
        type: SHAPE_TYPES.TRIANGLE,
        id: SHAPE_IDS.SMALL_TRIANGLE_BOTTOM,
        icon: 'SmallTriangle',
        prefix: 'SmallTriangle',
        label: 'Small Triangle Flipped',
        rotation: 180,
        w: 60,
        h: Math.round(60 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
]

export const MENU: GridShapesMenu = {
  list: [
    {
      title: 'Shapes:',
      items: [
        ...SHAPES.filter((s: Shape) => [
          SHAPE_IDS.HEX,
          SHAPE_IDS.LARGE_DIAMOND,
          SHAPE_IDS.SMALL_DIAMOND,
          SHAPE_IDS.LARGE_TRIANGLE_TOP,
          SHAPE_IDS.SMALL_TRIANGLE_TOP,
        ].includes(s.id as SHAPE_IDS)),
      ],
    },
  ],
  default: SHAPES.find((s: Shape) => SHAPE_IDS.HEX === s.id),
}
